export const calculateIsUserSubscribed = (unitUsers, userId) => {
  return unitUsers.some(user => user.uuid === userId);
};
